import { Compatibility } from '../helpers/compatibility';

export class ResponseError implements Error {
  public readonly name: string = 'ResponseError';
  public readonly message: string;
  status: number;
  url: string;
  statusText: string;
  responseText: string;

  constructor(url: string, status: number, statusText: string, responseText: string) {
    this.url = url;
    this.status = status;
    this.statusText = statusText;
    this.responseText = responseText;
    this.message = this.toString();
  }

  toString(): string {
    let result = `Failed to load ${this.url}\nServer responded: ${this.status}`;
    if (!Compatibility.IsIE) {
      result += ` ${this.statusText}\n${this.responseText}`;
    }
    return result;
  }
}
